module.exports = "<h2 (click)=\"onClick.emit()\">\n  {{ text }}\n</h2>";